import { render, staticRenderFns } from "./MenuParent.vue?vue&type=template&id=0d3b7022&scoped=true&"
import script from "./MenuParent.vue?vue&type=script&lang=js&"
export * from "./MenuParent.vue?vue&type=script&lang=js&"
import style0 from "./MenuParent.vue?vue&type=style&index=0&id=0d3b7022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3b7022",
  null
  
)

export default component.exports